import React, { FC, useState } from 'react';
import FormField from '@ingka/form-field';
import InputField from '@ingka/input-field';
import { NumericFormat } from 'react-number-format';
import { Controller, useFormContext } from 'react-hook-form';
import { CustomNumberInputProps } from './CustomNumberInputProps';
import { validateNumber, getSuffixLabel, getValueByPath } from './utils';

const CustomNumberInput: FC<CustomNumberInputProps> = ({
  name,
  label,
  currencySymbol,
  dataTestID,
  customOnChange = () => {
    // do nothing
  },
  disabled = false,
  removeK = false,
  currencyRate,
  error,
  helperText,
}) => {
  const { control } = useFormContext();
  const [focused, setFocused] = useState(false);
  return (
    <Controller
      render={({ field: { onChange, value }, formState: { errors } }) => (
        <FormField
          valid={focused || (!getValueByPath(errors, name) && !error)}
          shouldValidate={
            !(focused || (!getValueByPath(errors, name) && !error))
          }
          className={'green-validation-disabled'}
          validation={{
            id: `validation-message-${name}`,
            msg: getValueByPath(errors, name)?.message || error,
            type: 'error',
          }}
          {...(helperText && {
            fieldHelper: {
              id: `helper-${name}`,
              msg: helperText,
              type: 'text',
            },
          })}
        >
          <NumericFormat
            value={focused ? value : value || 0}
            thousandSeparator
            // suffix={currencySymbol}
            id={name}
            label={label}
            type={'text'}
            data-testid={dataTestID}
            suffixLabel={getSuffixLabel(
              currencySymbol,
              value,
              currencyRate,
              removeK,
            )}
            onFocus={(e) => {
              if (disabled) return;
              setFocused(true);
              if (!value || value === '0') {
                e.target.value = '';
                onChange('');
              }
            }}
            onBlur={() => {
              setFocused(false);
              if (value === '' || isNaN(Number(value))) {
                onChange(0);
              }
            }}
            readOnly={disabled}
            className={disabled && 'read-only-input'}
            customInput={InputField}
            onValueChange={({ value: numericValue }) => {
              onChange(validateNumber(numericValue));
              customOnChange();
            }}
          />
        </FormField>
      )}
      control={control}
      name={name}
    />
  );
};

export default CustomNumberInput;
